export {}

const headerLineClamp = document.querySelectorAll<HTMLElement>(".--js-header-line-clamp")

headerLineClamp.forEach((item) => {
  const heading = item.querySelector(".--js-header-line-clamp-heading")
  const perex = item.querySelector(".--js-header-line-clamp-perex")
  const max = parseInt(item.dataset.headerLineClampMax ?? "4")

  if(!perex || !heading) return
  const calculateLineClamp = (max : number) => {
    const elementHeight = heading.clientHeight
    const lineHeight = parseFloat(window.getComputedStyle(heading).lineHeight)
    const lines = Math.round(elementHeight / lineHeight)
    for (let i = 0; i < max; i++) {
      perex?.classList.remove(`u-clamp-${i}`)
    }

    perex?.classList.add(`u-clamp-${max - lines}`)
  }

  calculateLineClamp(max)

  window.addEventListener("resize", () => calculateLineClamp(max))
})
